import { decryptText } from "./cryptoUtils";

export function isAdmin() {
  const role = decryptText(localStorage.getItem("role"));
  return role && role.toLowerCase() === "admin";
}

export function isAdminOrIsUser() {
  const role = decryptText(localStorage.getItem("role"));

  return (
    (role && role.toLowerCase() === "admin") ||
    (role && role.toLowerCase() === "user")
  );
}
export function isUser() {
  const role = decryptText(localStorage.getItem("role"));
  return role && role.toLowerCase() === "user";
}
